// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../config/screen';

export const PanelContainer = styled.div`
  background-color: ${({ theme }) => theme.color.settings.panelBackgroundColor};
  min-height: calc(100dvh - 64px);
`;

export const PageHeaderContainer = styled.div`
  padding: 2rem 2rem 1rem;

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 2.5rem 2.5rem 1.25rem;
  };
`;

export const RegisteredTrademark = styled.sup`
  font-size: 0.8125rem;
`;

/* ************** PROFILE SETTINGS ******************* */

export const ProfileSettingsContainer = styled.div`
  height: 100%;
`;

/* ************** MOBILE BACK HEADER ******************* */

export const MobileBackHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.color.sideNavigation.borderColor};
`;
